import React from "react";
import Avatar from "@material-ui/core/Avatar";

export default function AvatarComponent(props){
    const { children, className, onClick } = props;

    return (
        <Avatar className={className} onClick={onClick}>
            {children}
        </Avatar>
    )
}